import Field, { type Flavor } from '../../Field';
import { type CardLayoutModelConstructorType } from '../../types';

export class ProgramIncrementField extends Field {
  static availableForModel(modelClass, recordLayout) {
    return (
      super.availableForModel(modelClass, recordLayout) &&
      window.currentAccount?.teamworkOrDevelopAdvanced
    );
  }

  static get availableForFlavors(): readonly Flavor[] {
    return ['develop', 'teamwork'];
  }

  static subqueriesForModel(
    modelClass: CardLayoutModelConstructorType
  ): Record<string, any> {
    return { programIncrement: ['name'] };
  }
}
